var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"content":_vm.text,"disabled":!_vm.showTip,"placement":_vm.placement}},[_c('div',{ref:"textDom",staticClass:"text-show-tip",style:(_vm.cssObject)},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }